module.exports = __webpack_public_path__ + "img.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/img.png
// module id = 389
// module chunks = 0